export default __webpack_public_path__ + "static/media/15.034eb4d6.jpeg";